module.exports = __webpack_public_path__ + "img/可口可乐.1b1b4613.jpg";